import { SVGProps } from "react";

export function GoogleBrand(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.501 12.4816C22.501 11.6183 22.4296 10.9883 22.2748 10.335H12.2153V14.2316H18.12C18.001 15.1999 17.3582 16.6583 15.9296 17.6382L15.9096 17.7687L19.0902 20.1834L19.3106 20.205C21.3343 18.3733 22.501 15.6783 22.501 12.4816Z"
        fill="#4285F4"
      />
      <path
        d="M12.214 22.7484C15.1068 22.7484 17.5353 21.815 19.3092 20.205L15.9282 17.6383C15.0235 18.2566 13.8092 18.6883 12.214 18.6883C9.38069 18.6883 6.97596 16.8566 6.11874 14.325L5.99309 14.3354L2.68583 16.8438L2.64258 16.9616C4.40446 20.3916 8.0235 22.7484 12.214 22.7484Z"
        fill="#34A853"
      />
      <path
        d="M6.12046 14.3251C5.89428 13.6718 5.76337 12.9718 5.76337 12.2485C5.76337 11.5251 5.89428 10.8251 6.10856 10.1718L6.10257 10.0326L2.75386 7.48401L2.64429 7.53508C1.91814 8.95843 1.50146 10.5568 1.50146 12.2485C1.50146 13.9401 1.91814 15.5384 2.64429 16.9618L6.12046 14.3251Z"
        fill="#FBBC05"
      />
      <path
        d="M12.2141 5.80839C14.2259 5.80839 15.583 6.66005 16.3569 7.37176L19.3807 4.47841C17.5236 2.78675 15.1069 1.74841 12.2141 1.74841C8.02353 1.74841 4.40447 4.10506 2.64258 7.53503L6.10686 10.1717C6.97598 7.64007 9.38073 5.80839 12.2141 5.80839Z"
        fill="#EB4335"
      />
    </svg>
  );
}
